import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskIncidentManagementRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-incident-management',
	path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
	exact: true,
};
